import { render, staticRenderFns } from "./TwoFactorCode.vue?vue&type=template&id=0ede6276&scoped=true&"
import script from "./TwoFactorCode.vue?vue&type=script&lang=js&"
export * from "./TwoFactorCode.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorCode.vue?vue&type=style&index=0&id=0ede6276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede6276",
  null
  
)

export default component.exports